if(!customElements.get('quick-add')) {
  class QuickAdd extends HTMLElement {
    static observedAttributes = ['variant-id', 'subscription'];

    constructor() {
      super();

      this.variantId = this.getAttribute('variant-id');
      this.subscription = this.getAttribute('subscription');
      this.promotion = this.getAttribute('promotion');

      this.elButton = this.querySelector('button');
      this.elStatus = this.querySelector('[data-status]');
      this.elButton && (this.elButton.onclick = this.addToCart.bind(this));
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if(name == 'variant-id') {
        this.variantId = newValue;
      } else if(name == 'subscription') {
        this.subscription = newValue;
      }
    }

    addToCart(ev) {
      ev.preventDefault(); 
      if(this.variantId) {
        const id = Number(this.variantId);

        const data = { 
          id,
          quantity: 1,
          ...(this.subscription && { selling_plan: this.subscription } ),
          ...(this.promotion && { properties: { '_promotion': this.promotion } } )
        };

        this.classList.add('adding');
        this.elStatus.innerHTML = `Adding <span class="visually-hidden">${id} to cart</span>...`;
        this.elButton.disabled = true;

        window.addToCart(data)
          .then(response => {
            this.classList.remove('adding');
            if(response.status) {
              this.classList.add('error');
              this.elStatus.innerHTML = `Error<span class="visually-hidden"> adding ${id} to cart</span>`;
            } else {
              this.classList.add('success');
              this.elStatus.innerHTML = `Added <span class="visually-hidden">${id}</span> to cart`;
            }
            setTimeout(() => this.resetState(), 5000);
          });
      }
    }

    resetState() {
      this.classList.remove("error");
      this.classList.remove("success");
      this.elButton.disabled = false;
      setTimeout(() => {
        this.elStatus.innerHTML = "";
      }, 300);
    }
  }

  customElements.define('quick-add', QuickAdd);
}